import styled from "styled-components";

export const Card = styled.div`
  background: #ffff;
  height: 50rem;
  border-radius: 2.3rem;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1);
`;

export const CardHeading = styled.header`
  font-size: 1.5rem;
  text-align: start;
  font-weight: 700;
  color: #071242;
  margin-bottom: 1.2rem;
`;

export const CardHeader = styled.div`
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
  width: 100%;
`;
export const Description = styled.div`
  font-size: 1.5rem;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 4%;
  align-items: center;
  color: #071242;
`;